module.exports = __webpack_public_path__ + "img/imageGalery2.d3c1387e.jpg";